module.exports = __webpack_public_path__ + "static/assets/14f9d56d55436cf7fad1167a0261f318.png";